// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*#region Blue*/
/*#endregion */
/*#region Blue-Grey*/
/*#endregion */
/*#region Red*/
/*#endregion */
/*#region Green*/
/*#endregion */
/*#region Yellow*/
/*#endregion*/
/*#region Misc*/
/*#endregion*/
/*#region Text*/
/*#endregion */
/*#region Elements*/
/**#region Event Container */
/*#endregion*/
/*#endregion */
/* #region Screen */
/* #endregion*/
/* Keep the familiar side-by-side row; flex only for alignment. */
.announcement-search-row {
  display: flex;
  align-items: center;
  gap: 2%;
}

.announcement-dropdown-container,
.announcement-input-container {
  width: 49%;
  flex: 0 0 49%;
}

.announcement-warning-container {
  border: 2px solid #cf6363;
  box-sizing: border-box;
  border-radius: 5px;
  display: flex;
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
}

.replacement-warning-text {
  color: #eec9c9;
}

.status-icon {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  margin: 5px 10px 5px 5px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
.status-icon > .status-icon-svg {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
}
.status-icon.replaced > .status-icon-svg {
  background-image: url('Attention.9bb70de13d884f60.svg');
}

.announcement-results {
  margin-top: 10px;
}

.announcement-text-label {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 400;
}

.announcement-text-option {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  padding: 10px 0;
}
.announcement-text-option input[type=radio] {
  -webkit-appearance: none;
          appearance: none;
  width: 18px;
  height: 18px;
  margin: 0;
  flex: 0 0 18px;
  border: 2px solid #9dbcda;
  border-radius: 50%;
  background: transparent;
  display: grid;
  place-content: center;
  cursor: pointer;
}
.announcement-text-option input[type=radio]::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ffffff;
  transform: scale(0);
}
.announcement-text-option input[type=radio]:checked {
  border-color: #3e84c9;
  background: #3e84c9;
}
.announcement-text-option input[type=radio]:checked::before {
  transform: scale(1);
}
.announcement-text-option input[type=radio]:disabled {
  border-color: #3f5061;
  cursor: default;
}
.announcement-text-option input[type=radio]:disabled:checked {
  background: #3f5061;
  border-color: #3f5061;
}

.announcement-text-option__label {
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: 0;
  font-size: 14px;
  line-height: 1.3;
  color: #9dbcda;
  cursor: pointer;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
